<div class="login-page">
    <!-- Layer 1: full-screen particle background -->
    <app-particle-background class="bg-layer"></app-particle-background>
  
    <!-- Layer 2: Bootstrap grid — card sits right side -->
    <div class="card-layer">
      <div class="container-fluid h-100">
        <div class="row h-100 align-items-center">
  
          <!-- left spacer -->
          <div class="col-md-8"></div>
  
          <!-- card column — swaps between the three views -->
          <div class="col-md-3 col-12">
  
            <app-login-card
              *ngIf="currentView === 'login'"
              (loginSubmit)="handleLogin($event)"
              (forgotPassword)="showForgotPassword()">
            </app-login-card>
  
            <app-forgot-password-card
              *ngIf="currentView === 'forgot-password'"
              (forgotPasswordSubmit)="handleForgotPassword($event)"
              (backToLogin)="backToLogin()">
            </app-forgot-password-card>
  
            <app-new-password-card
              *ngIf="currentView === 'new-password'"
              [email]="pendingEmail"
              (newPasswordSubmit)="handleNewPassword($event)"
              (backToLogin)="backToLogin()">
            </app-new-password-card>
  
          </div>
  
          <!-- right margin -->
          <div class="col-md-1"></div>
        </div>
      </div>
    </div>
  </div>